import { createSlice } from "@reduxjs/toolkit";
import { getPagedPaymentHistoryReport } from "./thunk";
export const initialState = {
  // Get Paged Payment History Report
  getPagedPaymentHistoryReportData: [],
  getPagedPaymentHistoryReportError: {},
  isgetPagedPaymentHistoryReportSuccess: false,
};

const PaymentSlice = createSlice({
  name: "PaymentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Paged Payment History Report
    builder.addCase(
      getPagedPaymentHistoryReport.fulfilled,
      (state: any, action: any) => {
        state.getPagedPaymentHistoryReportData = action.payload;
        state.isgetPagedPaymentHistoryReportSuccess = true;
      },
    );
    builder.addCase(
      getPagedPaymentHistoryReport.rejected,
      (state: any, action: any) => {
        state.getPagedPaymentHistoryReportError = action.payload || null;
      },
    );
  },
});

export default PaymentSlice.reducer;
